<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout justify-center align-center class="text-sm-left manage-report-container">
        <v-card width="100%">
          <v-card-title>
            <span v-if="stepper === 1">Meldungen</span>
            <span v-else>Meldungen von ({{selected.name}})</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <v-stepper v-model="stepper">
                  <v-stepper-header class="teal lighten-5">
                    <v-stepper-step :editable="stepper > 1" :complete="stepper > 1" step="1">
                      {{ $t('hotel.edit.select') }}
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stepper > 2" :editable="stepper > 2" step="2">
                      Meldungen
                    </v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-data-table
                        :headers="headers"
                        :items="hotels"
                        :page.sync="pagination"
                        :items-per-page.sync="itemsPerPage"
                        :server-items-length="total"
                        :footer-props="{itemsPerPageOptions: [10, 25, 50, 75, 100]}"
                        :loading="loading">
                        <template v-slot:item="props">
                          <tr>
                            <td>
                              <v-layout wrap>
                                <v-flex xs12 mt-5>
                                  <h2>{{ props.item.name }}</h2>
                                  <p>{{ props.item.channel }}</p>
                                </v-flex>
                              </v-layout>
                            </td>
                            <td class="text-sm-right">
                              <v-btn outlined color="primary" style="margin: 0;" @click="selectHotel(props.item)">
                                {{ $t('hotel.create.select') }}
                              </v-btn>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-layout wrap row pa-3 v-if="!dialog">
                        <v-flex xs12 v-if="ratePlans.length === 0">
                          Kein Datum ohne Preisdefinition gefunden
                        </v-flex>
                        <v-flex xs12 v-else>
                          <v-expansion-panels accordion>
                            <v-expansion-panel v-for="rate in ratePlans" :key="rate.id">
                              <v-expansion-panel-header>{{getName(rate)}}</v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-card flat>
                                  <v-card-text>
                                    <h4 style="margin-bottom: 15px;color: #dc0000;">Tage wo kein Preis definiert ist</h4>
                                    <div v-if="rate.dynamicDays.length > 0"> <!-- #303030 -->
                                      <div class="report-calendar">
                                      <span v-for="(day, index) in rate.dynamicDays" :key="day.id">
                                        <span :class="['report-day', {'report-warning': hasAvailability(day)}]">
                                          <div class="report-day-header">{{day.from | day}}</div>
                                          {{day.from | date}}
                                          <div class="report-day-footer">Verfügbarkeit: {{day.availableRooms}}</div>
                                        </span>
                                      <div class="report-split" v-if="checkSplit(index, rate.dynamicDays)"></div>
                                      </span>
                                      </div>

                                    </div>
                                    <div v-else>
                                      Kein Datum ohne Preisdefinition gefunden
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>

                  </v-stepper-items>
                </v-stepper>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
      <v-dialog
        v-model="dialog"
        hide-overlay
        persistent
        width="300">
        <v-card
          color="primary"
          dark>
          <v-card-text>
            Raten werden geladen
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
  export default {
    name: 'Report',
    data() {
      return {
        snackbar: {
          result: 'success',
          timeout: 6000,
          value: false,
          text: ''
        },
        stepper: 1,
        loading: false,
        total: 0,
        pagination: undefined,
        itemsPerPage: 10,
        hotels: [],
        ratePlans: [],
        headers: [
          {
            text: this.$i18n.t('hotel.create.hotelName'),
            sortable: false, value: 'name'
          },
          {
            text: this.$i18n.t('manageYieldStaff.actions'),
            sortable: false, align: 'right'
          }
        ],
        selected: undefined,
        dialog: false
      };
    },
    watch: {
      pagination: {
        handler (pagination) {
          this.fetchData(pagination - 1);
        },
      },
      itemsPerPage: {
        handler (itemsPerPage) {
          this.itemsPerPage = itemsPerPage;
          this.fetchData(this.pagination - 1);
        },
      }
    },
    mounted() {
      this.pagination = 1;
    },
    methods: {
      fetchData(pagination) {
        this.loading = true;
        this.$http.get('hotels/pagination?size='.concat(this.itemsPerPage)
          .concat('&page=').concat(pagination)).then((body) => {
          this.hotels = body.data.content;
          this.total = body.data.totalElements;
          this.loading = false;
        });
      },
      fetchRatesPlans() {
        this.dialog = true;
        this.$http.get('dynamic/empty/'.concat(this.selected.id)).then((data) => {
          this.ratePlans = data.body;
          this.dialog = false;
        });
      },
      selectHotel(hotel) {
        this.selected = hotel;
        this.stepper = 2;
        this.fetchRatesPlans();
      },
      checkSplit(index, dynamicDays) {
        if (index < dynamicDays.length - 2) {
          const present = this.$moment(dynamicDays[index].from).format('MMMM');
          const next = this.$moment(dynamicDays[index + 1].from).format('MMMM');
          return present !== next;
        }
        return false;
      },
      hasAvailability(day) {
        return day.availableRooms > 0;
      },
      getName(rate) {
        if (this.selected.channel === 'KOGNITIV') {
          return rate.ratePlanCode;
        }
        return rate.roomCode;
      }
    },
  };
</script>

<style lang="scss">
  .manage-report-container {
    .v-stepper {
      box-shadow: none;
      .v-stepper__content {
        padding: 0;
      }
    }

    .v-expansion-panel {
      .v-expansion-panel__container {
        .v-expansion-panel__header {
          font-size: 18px;
          font-weight: 600;
        }
      }
    }

    .report-calendar {
      color: white;
      .report-day {
        width: 140px;
        border: 1px solid white;
        display: inline-block;
        background-color: #303030;
        padding: 10px;
        &.report-warning {
          background-color: #e10000;
        }
        .report-day-header {
          font-weight: 600;
        }
        .report-day-footer {
          font-size: 10px;
        }
      }
      .report-split {
        height: 40px;
        width: 100%;
        display: block;
        background-color: white;
      }
    }
  }
</style>
